/* eslint-disable @typescript-eslint/no-redeclare */
import {
  ANALYTICS_ASSETS_SEARCH,
  ANALYTICS_CAMPAIGNS_SEARCH,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS,
  ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS,
  ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS,
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
  GET_ANALYTICS_ASSETS_FILTERS,
  GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST,
  GET_ANALYTICS_WORKFLOW_LIST,
  GET_ANALYTICS_CAMPAIGNS_FILTERS,
  GET_ANALYTICS_WORKFLOW_FILTERS,
  ANALYTICS_DASHBOARD,
  ANALYTICS_WORKFLOWS_SEARCH,
  ANALYTICS_DASHBOARD_WORKFLOW,
  ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS,
  GET_ANALYTICS_FILTERS_DROPDOWN_DATA,
} from 'constants/types';

import {
  IAssetDropdownItem,
  ICampaignDropdownItem,
  IDropdownCampaignItem,
  IEmailDropdownItem,
  IGraphDataAction,
  ILoadingOptionsWithData,
  ISearchedEmailDropdownList,
  IWorkflowDropdownItem,
} from '../interfaces';
import { getDateObject, searchExactMatchesWithArrayObject } from 'utils';

const initialAnalyticsDashboard = {
  data: {},
  total_delivered: 0,
  total_bounced: 0,
  total_unsubscribed: 0,
  exportLoading: false,
  loading: false,
  campaignsAssetsLoading: false,
  campaignsLoading: false,
  assetsLoading: false,
  isFilters: false,
  isCampaignSearch: false,
  campaignSearchTerm: '',
  isCampaignFilter: false,
  campaignsFilters: { isAllCampaigns: false, isCustom: false, isHybrid: false },
  appliedCampaignsFilters: {
    isAllCampaigns: false,
    isShareProfile: false,
    isDailyIQ: false,
    isWeeklyAccountInsights: false,
    isWorkflow: false,
  },
  campaignsFiltersIsCustom: false,
  campaignsFiltersIsHybrid: false,
  campaigns: Array<IDropdownCampaignItem>(),
  filteredCampaigns: Array<IDropdownCampaignItem>(),
  searchedCampaigns: Array<IDropdownCampaignItem>(),
  selectedCampaignsIds: [],
  excludeCampaignsIds: [], // state to add the campaigns Ids which are unselected if AllCampaign filter is applied
  appliedCampaignIds: [],
  appliedExcludeCampaignIds: [],
  queryParamsRemoved: false,
  campaignsLimitReached: false, // max 4 campaigns can be selected
  total_campaigns: 0,
  isAssetSearch: false,
  assetSearchTerm: '',
  firstTimeSearch: false,
  isAssetFilter: false,
  isTestEmailFilter: false,
  assetFilters: { isCustom: false, isHybrid: false, isAllType: true, isAIEmail: false },
  assetFiltersIsCustom: false,
  assetFiltersIsHybrid: false,
  dropdownEmailLoading: false,
  totalDropdownEmailsCount: 0,
  prevTotalDropdownEmailsCount: 0,
  totalSearchDropdownEmailsCount: 0,
  assets: Array<IEmailDropdownItem>(),
  filteredAssets: Array<IEmailDropdownItem>(),
  searchedAssets: Array<IEmailDropdownItem>(),
  appliedAssets: Array<IEmailDropdownItem>(),
  selectedAssetsIdsObject: {},
  excludeAssetsIds: [], // state to add the assets Ids which are unselected if AllCampaign filter is applied
  appliedAssetsIdsObject: {},
  selectedAssetsIds: [],
  appliedAssetsIds: [],
  appliedExcludeAssetsIds: [],
  total_assets: 0,
  redirectUrl: '',
  assetsLimitReached: false,
  saved_search_id: 0,
  showExportPopup: false,
  showExportPopupError: false,
  exportEmail: 'demo@mail.com',
  filterReset: false,
  firstRenderDone: false,
  isShareProfile: false,
  isDailyIQ: false,
  isWeeklyAccountInsights: false,
  isWorkflow: false,
  appliedIsWorkflow: false,
  firstAllDataShown: false, // for disabling dropdown while loading first time
  changeInAssetIds: false,
  isDefaultDataSet: false,
  statsLoading: false, // a loading state for the stats cards
  contentLoading: false, // a loading state for the top_accounts, top_people & top_content
  workflowSearchTerm: '',
  isWorkflowFilter: false,
  workflowFilters: { isActive: false, isInactive: false, isAllType: true },
  workflowsLoading: false,
  workflows: [],
  filteredWorkflows: Array<IWorkflowDropdownItem>(),
  searchedWorkflows: Array<IWorkflowDropdownItem>(),
  selectedWorkflowsIds: [],
  appliedWorkflowsIds: [],
  totalDropdownCampaignsCount: 0,
  dropdownCampaignLoading: false,
  unselectAllDropdownEmails: false,
  selectAllDropdownEmails: true,
  appliedUnselectAllDropdownEmails: false,
  appliedSelectAllDropdownEmails: true,
  searchedEmailList: Array<ISearchedEmailDropdownList>(),
  appliedSearchedEmailList: Array<ISearchedEmailDropdownList>(),
  totalDropdownEmailMarkedCount: 0,
  totalDropdownSearchEmailMarkedCount: 0,
  appliedEmailMarkedCount: 0,
  callEmailDropdownAPIOnCampaignUnset: false,
};

const emptyStats = {
  top_accounts: [],
  top_people: [],
  top_content: [],
  stats: {
    total_accounts: 0,
    total_contacts: 0,
    sent: 0,
    delivered: 0,
    opens: 0,
    clicks: 0,
    bounced: 0,
    unsubscribed: 0,
    unique_opens: 0,
    unique_clicks: 0,
    open_rate: 0,
    click_rate: 0,
    bounce_rate: 0,
    unsub_rate: 0,
    unique_clicks_rate: 0,
    unique_opens_rate: 0,
    delivered_rate: 0,
  },
  saved_search_id: 0,
};
export const analyticsDashboardReducer = (state: any = initialAnalyticsDashboard, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    //Cards Data
    case ANALYTICS_CARD_DATA.RENDER_DONE:
      newState.firstRenderDone = action.payload;
      return newState;
    case ANALYTICS_CARD_DATA.FILTER_RESET:
      newState.filterReset = action.payload;
      return newState;

    case ANALYTICS_CARD_DATA.LOAD:
      newState.statsLoading = true;
      return newState;
    case ANALYTICS_CARD_DATA.SUCCESS:
      newState.statsLoading = false;
      let modifiedState: any = {};

      if (action.payload) {
        modifiedState = { ...newState };
        modifiedState.saved_search_id = action.payload.saved_search_id;
        modifiedState.stats = action.payload.stats;
      }
      return modifiedState;
    case ANALYTICS_CARD_DATA.FAIL:
      newState.statsLoading = false;
      return { ...newState, ...emptyStats };
    case ANALYTICS_CARD_DATA.RESET:
      return newState;

    case ANALYTICS_CARD_DATA.SET_FIRST_ALL_DATA_SHOWN:
      newState.firstAllDataShown = action.payload;
      return newState;

    //Intent Data
    case ANALYTICS_INTENT_DATA.LOAD:
      newState.contentLoading = true;
      return newState;
    case ANALYTICS_INTENT_DATA.SUCCESS:
      newState.contentLoading = false;
      let _modifiedState: any = {};
      if (action.payload) {
        _modifiedState = { ...newState };
        _modifiedState.top_people = action.payload.top_people;
        _modifiedState.top_accounts = action.payload.top_accounts;
        _modifiedState.top_content = action.payload.top_content;
      }
      return _modifiedState;
    case ANALYTICS_INTENT_DATA.FAIL:
      newState.contentLoading = false;
      return { ...newState, ...emptyStats };
    case ANALYTICS_INTENT_DATA.RESET:
      return newState;
    case ANALYTICS_INTENT_DATA.EXPORT_LOAD:
      if (action.payload?.type === 'contacts') {
        newState.total_delivered = action.payload.total_delivered ?? newState.total_delivered;
        newState.total_bounced = action.payload.total_bounced ?? newState.total_bounced;
        newState.total_unsubscribed = action.payload.total_unsubscribed ?? newState.total_unsubscribed;
        if (
          newState.total_delivered <= 0 &&
          newState.total_bounced <= 0 &&
          newState.total_unsubscribed <= 0 &&
          (!action.payload.offset || action.payload.offset <= 0)
        )
          newState.exportLoading = true;
        else newState.exportLoading = false;
      } else {
        newState.exportLoading = action.payload;
      }
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_FILTERS:
      if (action.payload) {
        let obj = { ...state.campaignsFilters, ...action.payload };
        let isAllCampaigns = obj.isAllCampaigns;
        let isHybrid = obj.isHybrid;
        let isCustom = obj.isCustom;
        if (isHybrid && isCustom) {
          newState.filteredCampaigns = state.campaigns.filter((item: any) => item.isHybrid === isHybrid && item.isCustom === isCustom);
        } else if (isHybrid) {
          newState.filteredCampaigns = state.campaigns.filter((item: any) => item.isHybrid === isHybrid);
        } else if (isCustom) {
          newState.filteredCampaigns = state.campaigns.filter((item: any) => item.isCustom === isCustom);
        } else {
          newState.filteredCampaigns = [];
        }
        newState.campaignsFilters.isAllCampaigns = isAllCampaigns;
        newState.campaignsFilters.isCustom = isCustom;
        newState.campaignsFilters.isHybrid = isHybrid;
        if (isAllCampaigns) {
          newState.campaignsLimitReached = false;
        }
        if (state.isCampaignSearch) {
          let srchCampaigns = [];
          if (!isCustom && !isHybrid) {
            srchCampaigns = newState.campaigns.filter((item: any) => item?.name?.toLowerCase().includes(state.campaignSearchTerm?.toLowerCase()));
          } else {
            srchCampaigns = newState.filteredCampaigns.filter((item: any) =>
              item?.name?.toLowerCase().includes(state.campaignSearchTerm?.toLowerCase()),
            );
          }
          newState.searchedCampaigns = srchCampaigns;
        }
        if (isAllCampaigns) {
          newState.campaignsLimitReached = false;
          newState.changeInAssetIds = true;
        }
      }

      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.RESET:
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.REORDER_CAMPAIGNS:
      let beforeCampaigns: ICampaignDropdownItem[] = [];
      let afterCampaigns: ICampaignDropdownItem[] = [];
      state.campaigns.forEach((item: ICampaignDropdownItem) => {
        if (state.selectedCampaignsIds.includes(item.id)) {
          beforeCampaigns.push(item);
        } else {
          afterCampaigns.push(item);
        }
      });
      newState.campaigns = [...beforeCampaigns, ...afterCampaigns];
      return newState;

    case GET_ANALYTICS_ASSETS_FILTERS.SET_FILTERS:
      const { selectedFilter, selectedDate } = action.payload;
      let filteredList: IAssetDropdownItem[] = [];
      if (!Object.keys(selectedFilter).length) {
        filteredList = getFilteredList(
          state.assetFilters,
          newState.isAssetSearch,
          newState.assetSearchTerm,
          [...newState.assets],
          state.selectedCampaignsIds,
          newState.isTestEmailFilter,
          selectedDate,
        );
        newState.filteredAssets = filteredList;
      } else if (!state.assetFilters[selectedFilter]) {
        let filter = Object.keys(selectedFilter)[0];
        let obj = {
          isCustom: false,
          isHybrid: false,
          isAllType: false,
          isAIEmail: false,
          [filter]: true,
        };
        filteredList = getFilteredList(
          obj,
          newState.isAssetSearch,
          newState.assetSearchTerm,
          newState.isWorkflow ? newState.filteredAssets : [...newState.assets],
          state.selectedCampaignsIds,
          newState.isTestEmailFilter,
          selectedDate,
        );
        newState.assetFilters = obj;
        if (newState.isAssetSearch) {
          newState.searchedAssets = filteredList;
        } else {
          newState.filteredAssets = filteredList;
        }
      }
      return newState;

    case GET_ANALYTICS_ASSETS_FILTERS.REORDER_ASSETS:
      let beforeEmails: IAssetDropdownItem[] = [];
      let afterEmails: IAssetDropdownItem[] = [];
      let objectAssets: any = { ...state.selectedAssetsIdsObject };
      Object.keys(state.selectedAssetsIdsObject).forEach((key: string) => {
        if (!state.selectedCampaignsIds.includes(parseInt(key))) {
          delete objectAssets[key];
        }
      });
      let tempIds5: any = [];
      Object.values(objectAssets).forEach((item: any) => {
        tempIds5 = [...tempIds5, ...item];
      });
      newState.selectedAssetsIdsObject = { ...objectAssets };

      let assetsList;
      if (state.assetSearchTerm) {
        assetsList = [...state.searchedAssets];
      } else {
        assetsList = [...state.filteredAssets];
      }

      assetsList.forEach((item: IAssetDropdownItem) => {
        if (state.selectedAssetsIds.includes(item.id)) {
          beforeEmails.push(item);
        } else {
          afterEmails.push(item);
        }
      });
      afterEmails.sort((a, b) => a.dateTime.localeCompare(b.dateTime));
      beforeEmails.sort((a, b) => a.dateTime.localeCompare(b.dateTime));

      if (state.assetSearchTerm) {
        newState.searchedAssets = [...beforeEmails, ...afterEmails];
      } else {
        newState.filteredAssets = [...beforeEmails, ...afterEmails];
      }
      return newState;

    case GET_ANALYTICS_ASSETS_FILTERS.SET_TEST_EMAIL_FILTER:
      newState.isTestEmailFilter = true;
      return newState;

    case GET_ANALYTICS_ASSETS_FILTERS.RESET_TEST_EMAIL_FILTER:
      newState.isTestEmailFilter = false;
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.LOAD:
      newState.campaignsAssetsLoading = true;
      return newState;
    case GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.SUCCESS:
      newState.campaignsAssetsLoading = false;
      newState.campaigns = action.payload.campaigns;
      newState.assets = action.payload.assets;
      newState.total_campaigns = action.payload.total_campaigns;
      newState.total_assets = action.payload.total_emails;
      if (action.payload.allCampaigns) newState.filteredAssets = action.payload.assets;
      else if (state.selectedCampaignsIds.length) {
        newState.filteredAssets = newState.assets.filter((asset: IAssetDropdownItem) => state.selectedCampaignsIds.includes(asset.campaignId));
      } else newState.filteredAssets = [];
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.FAIL:
      newState.campaignsAssetsLoading = false;
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.RESET:
      newState.campaignsAssetsLoading = false;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET:
      let selectedCampaignsIds = [...state.selectedCampaignsIds];

      if (state.campaignsLimitReached) newState.campaignsLimitReached = false;
      let campaign_Id = action.payload;
      let index = selectedCampaignsIds.findIndex((id: any) => id == campaign_Id);
      if (index > -1) {
        // removing from the lists
        selectedCampaignsIds = state.selectedCampaignsIds.filter((id: any) => id !== campaign_Id);
      } else {
        // adding in the lists
        selectedCampaignsIds = [...selectedCampaignsIds, campaign_Id];
      }
      newState.selectedCampaignsIds = [...selectedCampaignsIds];
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET:
      if (
        newState.isWeeklyAccountInsights ||
        newState.isDailyIQ ||
        newState.isShareProfile ||
        newState.campaignsFilters.isAllCampaigns ||
        newState.isWorkflow
      ) {
        newState.changeInAssetIds = true;
      } else if (newState.appliedCampaignIds.length !== newState.selectedCampaignsIds.length) {
        newState.changeInAssetIds = true;
      } else if (
        newState.appliedAssetsIds.length !== newState.selectedAssetsIds.length ||
        newState.excludeAssetsIds !== newState.appliedExcludeAssetsIds
      ) {
        newState.changeInAssetIds = true;
      } else {
        newState.changeInAssetIds = false;

        newState.appliedCampaignIds.forEach((appliedId: any) => {
          if (!newState.selectedCampaignsIds?.includes(appliedId)) {
            newState.changeInAssetIds = true;
          }
        });

        if (newState.changeInAssetIds === false) {
          newState.appliedAssetsIds.forEach((appliedId: any) => {
            if (!newState.selectedAssetsIds?.includes(appliedId)) {
              newState.changeInAssetIds = true;
            }
          });

          newState.appliedExcludeAssetsIds.forEach((appliedId: number) => {
            if (!newState.excludeAssetsIds?.includes(appliedId)) {
              newState.changeInAssetIds = true;
            }
          });
        }
      }
      newState.appliedCampaignIds = [...newState.selectedCampaignsIds];
      newState.appliedExcludeCampaignIds = [...newState.excludeCampaignsIds];
      newState.appliedAssetsIds = [...newState.selectedAssetsIds];
      newState.appliedExcludeAssetsIds = [...newState.excludeAssetsIds];
      newState.appliedAssetsIdsObject = { ...newState.selectedAssetsIdsObject };
      newState.appliedWorkflowsIds = [...newState.selectedWorkflowsIds];
      newState.appliedSelectAllDropdownEmails = newState.selectAllDropdownEmails;
      newState.appliedUnselectAllDropdownEmails = newState.unselectAllDropdownEmails;
      newState.appliedSearchedEmailList = [...newState.searchedEmailList];
      newState.appliedEmailMarkedCount = newState.totalDropdownEmailMarkedCount;
      newState.prevTotalDropdownEmailsCount = newState.totalDropdownEmailsCount;
      newState.appliedAssets = newState.assets.map((email: IEmailDropdownItem) => ({ ...email }));
      newState.appliedStartDate = newState.startDate;
      newState.appliedEndDate = newState.endDate;
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET:
      // newState.appliedCampaignIds.forEach((appliedId: any) => {
      //   if (!newState.selectedCampaignsIds?.includes(appliedId)) {
      //     newState.callEmailDropdownAPIOnCampaignUnset = true;
      //   }
      // });
      // newState.appliedWorkflowsIds.forEach((appliedId: any) => {
      //   if (!newState.selectedWorkflowsIds?.includes(appliedId)) {
      //     newState.callEmailDropdownAPIOnCampaignUnset = true;
      //   }
      // });
      newState.selectedCampaignsIds = [...newState.appliedCampaignIds];
      newState.selectedWorkflowsIds = [...newState.appliedWorkflowsIds];
      newState.selectedAssetsIds = [...newState.appliedAssetsIds];
      newState.excludeAssetsIds = [...newState.appliedExcludeAssetsIds];
      newState.searchedEmailList = [...newState.appliedSearchedEmailList];
      newState.selectAllDropdownEmails = newState.appliedSelectAllDropdownEmails;
      newState.unselectAllDropdownEmails = newState.appliedUnselectAllDropdownEmails;
      newState.assets = newState.appliedAssets.map((email: IEmailDropdownItem) => ({ ...email }));
      newState.totalDropdownEmailMarkedCount = newState.appliedEmailMarkedCount;
      newState.totalDropdownEmailsCount = newState.prevTotalDropdownEmailsCount;
      newState.isShareProfile = state.appliedCampaignsFilters.isShareProfile;
      newState.isDailyIQ = state.appliedCampaignsFilters.isDailyIQ;
      newState.isWeeklyAccountInsights = state.appliedCampaignsFilters.isWeeklyAccountInsights;
      newState.isWorkflow = state.appliedIsWorkflow;
      // newState.selectedAssetsIdsObject = { ...newState.appliedAssetsIdsObject };
      newState.startDate = newState.appliedStartDate;
      newState.endDate = newState.appliedEndDate;
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.REMOVE_QUERY_PARAMS_SET:
      newState.queryParamsRemoved = true;
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.REMOVE_QUERY_PARAMS_UNSET:
      newState.queryParamsRemoved = false;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET:
      let assetId = action.payload.asset_id;
      let showingEmails: IEmailDropdownItem[] = newState.isAssetSearch ? newState.searchedAssets : newState.assets;
      showingEmails = showingEmails.map((asset: IEmailDropdownItem) => {
        let isExistInSearchedEmailList = false;
        if (asset.id === assetId) {
          asset.isMarked = !asset.isMarked;
          newState.searchedEmailList = newState.searchedEmailList.map((item: ISearchedEmailDropdownList) => {
            const ids = item.emailIds.filter((id: number) => id !== assetId);
            if (ids.length !== item.emailIds.length) {
              isExistInSearchedEmailList = true;
              item.emailIds = ids;
            }
            return item;
          });
          if (newState.isAssetSearch) {
            const isIncludedInSearchedEmailItem =
              newState.searchedEmailList.length &&
              newState.searchedEmailList.filter((item: ISearchedEmailDropdownList) => item.term === newState.assetSearchTerm);
            if (isIncludedInSearchedEmailItem.length) {
              if (
                (asset.isMarked && !isIncludedInSearchedEmailItem[0].selectAll) ||
                (!asset.isMarked && isIncludedInSearchedEmailItem[0].selectAll)
              ) {
                isIncludedInSearchedEmailItem[0].emailIds.push(assetId);
              } else {
                isIncludedInSearchedEmailItem[0].emailIds = isIncludedInSearchedEmailItem[0].emailIds.filter((id: number) => id !== assetId);
              }
              isIncludedInSearchedEmailItem[0].emailIds =
                isIncludedInSearchedEmailItem[0].emailIds.length > 1
                  ? [...new Set(isIncludedInSearchedEmailItem[0].emailIds)]
                  : isIncludedInSearchedEmailItem[0].emailIds;
              newState.searchedEmailList = newState.searchedEmailList.map((item: ISearchedEmailDropdownList) => {
                if (item.term === isIncludedInSearchedEmailItem[0].term) {
                  return isIncludedInSearchedEmailItem[0];
                } else return item;
              });
            } else {
              if (!isExistInSearchedEmailList) {
                newState.searchedEmailList.push({
                  term: newState.assetSearchTerm,
                  selectAll: newState.totalSearchDropdownEmailsCount === newState.totalDropdownSearchEmailMarkedCount,
                  emailIds: [assetId],
                });
              }
            }
          }
          if (asset.isMarked) {
            // it means we have to add this in selectedAssetIds list
            if (!newState.isAssetSearch) {
              newState.selectedAssetsIds = [...newState.selectedAssetsIds, assetId];
            }
            newState.excludeAssetsIds = newState.excludeAssetsIds.filter((id: any) => id !== assetId);
            newState.totalDropdownEmailMarkedCount = newState.totalDropdownEmailMarkedCount + 1;
            if (newState.isAssetSearch) {
              newState.totalDropdownSearchEmailMarkedCount = newState.totalDropdownSearchEmailMarkedCount + 1;
            }
          } else {
            newState.selectedAssetsIds = newState.selectedAssetsIds.filter((id: any) => id !== assetId);
            if (!newState.isAssetSearch) {
              newState.excludeAssetsIds = [...newState.excludeAssetsIds, assetId];
            }
            newState.totalDropdownEmailMarkedCount = newState.totalDropdownEmailMarkedCount - 1;
            if (newState.isAssetSearch) {
              newState.totalDropdownSearchEmailMarkedCount = newState.totalDropdownSearchEmailMarkedCount - 1;
            }
          }
        }
        return asset;
      });
      if (newState.isAssetSearch) {
        newState.searchedAssets = showingEmails;
      } else {
        newState.assets = showingEmails;
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.SET:
      let workflowId = action?.payload?.workflow_id;
      let asset_Id = action.payload.asset_id;
      newState.assets = newState.assets.map((asset: IEmailDropdownItem) => {
        if (asset.id === asset_Id) {
          asset.isMarked = !asset.isMarked;
        }
        return asset;
      });

      if (newState.selectedAssetsIds.includes(asset_Id)) {
        newState.selectedAssetsIds = newState.selectedAssetsIds.filter((aId: any) => asset_Id !== aId);
      } else {
        newState.selectedAssetsIds = [...newState.selectedAssetsIds, asset_Id];
      }

      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.SELECT_ALL:
      const emailFilter = newState.assetFilters;
      if (emailFilter.isCustom) {
        const isCustomIds = newState.filteredAssets.filter((asset: any) => asset.isCustom === emailFilter.isCustom).map((asset: any) => asset.id);
        isCustomIds.forEach((id: any) => {
          if (!newState.selectedAssetsIds.includes(id)) {
            newState.selectedAssetsIds = [...newState.selectedAssetsIds, id];
          }
        });
      } else if (emailFilter.isHybrid) {
        const isHybridIds = newState.filteredAssets.filter((asset: any) => asset.isHybrid === emailFilter.isHybrid).map((asset: any) => asset.id);
        isHybridIds.forEach((id: any) => {
          if (!newState.selectedAssetsIds.includes(id)) {
            newState.selectedAssetsIds = [...newState.selectedAssetsIds, id];
          }
        });
      } else if (emailFilter.isAllType) {
        newState.selectedAssetsIds = newState.filteredAssets.map((asset: any) => asset.id);
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.UNSELECT_ALL:
      const assetFilter = newState.assetFilters;
      if (assetFilter.isCustom) {
        const isCustomIds = newState.filteredAssets.filter((asset: any) => asset.isCustom === assetFilter.isCustom).map((asset: any) => asset.id);
        newState.selectedAssetsIds = newState.selectedAssetsIds.filter((id: any) => !isCustomIds.includes(id));
      } else if (assetFilter.isHybrid) {
        const isHybridIds = newState.filteredAssets.filter((asset: any) => asset.isHybrid === assetFilter.isHybrid).map((asset: any) => asset.id);
        newState.selectedAssetsIds = newState.selectedAssetsIds.filter((id: any) => !isHybridIds.includes(id));
      } else if (assetFilter.isAllType) {
        newState.selectedAssetsIds = [];
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.RESET:
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.FILTER_LIST:
      const updatedFilter = Object.keys(action.payload)[0];
      let obj = {
        isCustom: false,
        isHybrid: false,
        isAllType: false,
        [updatedFilter]: true,
      };

      newState.assetFilters = obj;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.RESET:
      newState.selectedCampaignsIds = [];
      // newState.appliedCampaignIds = [];
      newState.campaignsFilters.allCampaigns = false;
      newState.campaignsFilters.isCustom = false;
      newState.campaignsFilters.isHybrid = false;
      newState.excludeCampaignsIds = [];
      if (action.payload) {
        newState.campaignsFilters.isAllCampaigns = false;
        newState.campaignsLimitReached = false;
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET_DEFAULT:
      const { campaignIds: cIds, emailId, date } = action.payload;
      newState.selectedCampaignsIds = cIds;
      newState.appliedCampaignIds = cIds;

      let updatedSelectedAssetsIds: number[] = [];

      let assetsItemIds = newState.assets.map((data: IAssetDropdownItem) => data.id);
      if (emailId) {
        updatedSelectedAssetsIds = [emailId];
      } else {
        updatedSelectedAssetsIds = [...assetsItemIds];
      }

      newState.selectedAssetsIds = updatedSelectedAssetsIds;
      newState.appliedAssetsIds = updatedSelectedAssetsIds;
      newState.isDefaultDataSet = true;
      return newState;

    case ANALYTICS_DASHBOARD.SET_DEFAULT_FLAG:
      newState.isDefaultDataSet = false;
      return newState;

    case ANALYTICS_DASHBOARD.SET_CAMPAIGN_LIMIT:
      newState.campaignsLimitReached = action.payload;
      return newState;

    case ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS:
      newState.appliedCampaignsFilters = {
        isShareProfile: state.isShareProfile,
        isDailyIQ: state.isDailyIQ,
        isWeeklyAccountInsights: state.isWeeklyAccountInsights,
        isAllCampaigns: state.campaignsFilters.isAllCampaigns,
      };
      newState.appliedIsWorkflow = state.isWorkflow;
      return newState;

    case ANALYTICS_DASHBOARD.RESET_CAMPAIGN_FILTERS:
      newState.isShareProfile = state.appliedCampaignsFilters.isShareProfile;
      newState.isDailyIQ = state.appliedCampaignsFilters.isDailyIQ;
      newState.isWeeklyAccountInsights = state.appliedCampaignsFilters.isWeeklyAccountInsights;
      newState.isWorkflow = state.appliedIsWorkflow;
      newState.campaignsFilters = {
        ...state.campaignsFilters,
        isAllCampaigns: state.appliedCampaignsFilters.isAllCampaigns,
      };
      return newState;

    case ANALYTICS_DASHBOARD.RESET_APPLIED_CAMPAIGN_FILTERS:
      newState.appliedCampaignsFilters = { ...initialAnalyticsDashboard.appliedCampaignsFilters };
      newState.appliedIsWorkflow = initialAnalyticsDashboard.appliedIsWorkflow;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SELECT_ALL:
      if (newState.isCampaignSearch) {
        const searchedSelectedCamapignIds = newState.searchedCampaigns.map((campaign: IDropdownCampaignItem) => campaign.id);
        newState.selectedCampaignsIds = [...newState.selectedCampaignsIds, ...searchedSelectedCamapignIds];
      } else {
        newState.selectedCampaignsIds = newState.campaigns.map((campaign: IDropdownCampaignItem) => campaign.id);
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.UNSELECT_ALL:
      if (newState.isCampaignSearch) {
        const searchedSelectedCamapignIds = newState.searchedCampaigns.map((campaign: IDropdownCampaignItem) => campaign.id);
        newState.selectedCampaignsIds = newState.selectedCampaignsIds.filter((id: number) => !searchedSelectedCamapignIds.includes(id));
      } else {
        newState.selectedCampaignsIds = [];
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SELECT_ALL:
      let emailIds: any[] = [];
      if (newState.isAssetSearch) {
        newState.searchedAssets = newState.searchedAssets.map((asset: IEmailDropdownItem) => {
          asset.isMarked = true;
          emailIds.push(asset.id);
          return asset;
        });
        newState.excludeAssetsIds = newState.excludeAssetsIds.filter((id: number) => !emailIds.includes(id));
        newState.selectedAssetsIds = newState.selectedAssetsIds.filter((id: number) => !emailIds.includes(id));
        const isIncludeSearchTerm =
          newState.searchedEmailList.length &&
          newState.searchedEmailList.filter((obj: ISearchedEmailDropdownList) => obj.term === newState.assetSearchTerm);
        if (!isIncludeSearchTerm.length) {
          const newSearchList: ISearchedEmailDropdownList = { term: newState.assetSearchTerm, selectAll: true, emailIds: [] };
          newState.searchedEmailList = [...newState.searchedEmailList, newSearchList];
        } else {
          newState.searchedEmailList = newState.searchedEmailList.map((searchItem: ISearchedEmailDropdownList) => {
            if (searchItem.term === newState.assetSearchTerm) {
              searchItem.selectAll = true;
              searchItem.emailIds = [];
            }
            return searchItem;
          });
        }
        newState.totalDropdownEmailMarkedCount =
          newState.totalDropdownEmailMarkedCount + (newState.totalSearchDropdownEmailsCount - newState.totalDropdownSearchEmailMarkedCount);
        newState.totalDropdownSearchEmailMarkedCount = newState.totalSearchDropdownEmailsCount;
      } else {
        newState.assets = newState.assets.map((asset: IEmailDropdownItem) => {
          asset.isMarked = true;
          emailIds.push(asset.id);
          return asset;
        });
        if (newState.isWorkflow) {
          newState.selectedAssetsIds = newState.assets.map((asset: IAssetDropdownItem) => asset.id);
        } else {
          newState.selectedAssetsIds = [];
        }
        newState.excludeAssetsIds = [];
        newState.selectAllDropdownEmails = true;
        newState.unselectAllDropdownEmails = false;
        newState.searchedEmailList = [];
        newState.totalDropdownEmailMarkedCount = newState.totalDropdownEmailsCount;
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.UNSELECT_ALL:
      if (newState.isAssetSearch) {
        let ids: number[] = [];
        newState.searchedAssets = newState.searchedAssets.map((asset: IEmailDropdownItem) => {
          asset.isMarked = false;
          ids.push(asset.id);
          return asset;
        });
        newState.selectedAssetsIds = newState.selectedAssetsIds.filter((id: number) => !ids.includes(id));
        newState.excludeAssetsIds = newState.excludeAssetsIds.filter((id: number) => !ids.includes(id));
        const isIncludeSearchTerm =
          newState.searchedEmailList.length &&
          newState.searchedEmailList.filter((obj: ISearchedEmailDropdownList) => obj.term === newState.assetSearchTerm);
        if (!isIncludeSearchTerm.length) {
          const newSearchList: ISearchedEmailDropdownList = { term: newState.assetSearchTerm, selectAll: false, emailIds: [] };
          newState.searchedEmailList = [...newState.searchedEmailList, newSearchList];
        } else {
          newState.searchedEmailList = newState.searchedEmailList.map((searchItem: ISearchedEmailDropdownList) => {
            if (searchItem.term === newState.assetSearchTerm) {
              searchItem.selectAll = false;
              searchItem.emailIds = [];
            }
            return searchItem;
          });
        }
        newState.totalDropdownEmailMarkedCount = newState.totalDropdownEmailMarkedCount - newState.totalDropdownSearchEmailMarkedCount;
        newState.totalDropdownSearchEmailMarkedCount = 0;
      } else {
        newState.assets = newState.assets.map((asset: IEmailDropdownItem) => {
          asset.isMarked = false;
          return asset;
        });
        newState.selectedAssetsIds = [];
        newState.excludeAssetsIds = [];
        newState.selectAllDropdownEmails = false;
        newState.unselectAllDropdownEmails = true;
        newState.searchedEmailList = [];
        newState.totalDropdownEmailMarkedCount = 0;
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.RESET:
      newState.selectedAssetsIds = [];
      newState.excludeAssetsIds = [];
      newState.searchedEmailList = [];
      newState.totalDropdownEmailMarkedCount = 0;
      newState.unselectAllDropdownEmails = false;
      newState.selectAllDropdownEmails = true;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.DATE_FILTER:
      let datesObject: any = getDateObject(action.payload.value);
      // settings the hours so that we can only compare on date and not on dateTime
      let startDate = new Date(datesObject.start_date).setHours(0, 0, 0, 0);
      let endDate = new Date(datesObject.end_date).setHours(0, 0, 0, 0);
      let newList = state.assets.filter((asset: IAssetDropdownItem) => {
        let date = new Date(asset.dateTime).setHours(0, 0, 0, 0);
        // following conditions are checking here
        // date should be in the range
        // assetSearchTerm should be a substring of a asset name
        // asset should be in the selected campaigns list if assetSearchTerm is empty
        // if there is any filter applied i.e.adhoc or digests then it should filter out the email accordingly
        if (newState.isAssetSearch) {
          if (
            date >= startDate &&
            date <= endDate &&
            checkAssetFilters(asset, state.assetFilters) &&
            checkSelectedOrSearchCampaigns(asset, state.assetSearchTerm, state.selectedCampaignsIds)
          ) {
            return asset;
          }
        } else {
          if (checkSelectedOrSearchCampaigns(asset, state.assetSearchTerm, state.selectedCampaignsIds)) {
            return asset;
          }
        }
      });
      // depending on the array used we push the updated list in the specified array.
      if (newState.isAssetSearch) {
        newState.searchedAssets = newList;
      } else {
        newState.filteredAssets = newList;
      }
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.FILTER_LIST:
      newState.filteredAssets = [...action.payload];
      return newState;
    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET_MULTIPLE:
      let assets = action?.payload?.assets;
      newState.filteredAssets = [...assets];
      newState.selectedAssetsIds = [...assets.map((asset: IAssetDropdownItem) => asset.id)];
      let m_newSelectedAssetsIdsObject: any = {};
      newState.campaigns.forEach((campaign: ICampaignDropdownItem) => {
        m_newSelectedAssetsIdsObject[campaign.id] = assets
          .filter((asset: IAssetDropdownItem) => asset.campaignId === campaign.id)
          .map((data: IAssetDropdownItem) => data.id);
      });
      newState.selectedAssetsIdsObject = m_newSelectedAssetsIdsObject;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET_SELECTED_ASSETS:
      newState.selectedAssetsIds = action.payload.ids;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET_EMAIL_DROPDOWN_USING_FILTER_ID:
      newState.selectAllDropdownEmails = action.payload.selectAll;
      newState.unselectAllDropdownEmails = action.payload.unselectAll;
      newState.searchedEmailList = action.payload.searchList;
      newState.excludeAssetsIds = action.payload.excludeAssetsIds;
      newState.selectedAssetsIds = action.payload.selectedAssetsIds;
      return newState;

    case ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.UNSELECT_MULTIPLE:
      let unselectAssetsIds = action?.payload.assets.map((item: IAssetDropdownItem) => item.id);
      // adding the asset in exclude list if All campaigns is checked
      if (state.campaignsFilters.isAllCampaigns) {
        newState.excludeAssetsIds = [...state.excludeAssetsIds, ...unselectAssetsIds];
      }
      let unselectSelectedAssetsObj = { ...state.selectedAssetsIdsObject };
      let unselectModifiedSelectedAssetsIds: number[] = [];
      Object.keys(state.selectedAssetsIdsObject).forEach((item) => {
        let idsList = [...state.selectedAssetsIdsObject[item]];
        idsList = idsList.filter((assetId) => !unselectAssetsIds.includes(assetId));
        if (idsList.length > 0) {
          unselectSelectedAssetsObj[item] = idsList;
        } else {
          unselectSelectedAssetsObj[item] = [];
        }
        unselectModifiedSelectedAssetsIds = [...unselectModifiedSelectedAssetsIds, ...idsList];
      });
      newState.selectedAssetsIdsObject = unselectSelectedAssetsObj;
      newState.selectedAssetsIds = unselectModifiedSelectedAssetsIds;
      newState.campaignsLimitReached = false;
      return newState;

    case ANALYTICS_CAMPAIGNS_SEARCH.SET:
      if (action.payload?.length > 0) {
        newState.campaignSearchTerm = action.payload;
        newState.isCampaignSearch = true;
        let { isCustom: campaignCustom, isHybrid: campaignHybrid } = state.campaignsFilters;
        let srchCampaigns = searchExactMatchesWithArrayObject(action?.payload?.toString(), state.campaigns);

        if (campaignCustom && campaignHybrid) {
          srchCampaigns = srchCampaigns.filter((item: any) => item.isCustom === true && item.isHybrid === true);
        } else if (campaignCustom) {
          srchCampaigns = srchCampaigns.filter((item: any) => item.isCustom === true);
        } else if (campaignHybrid) {
          srchCampaigns = srchCampaigns.filter((item: any) => item.isHybrid === true);
        } else {
        }
        newState.searchedCampaigns = [...srchCampaigns];
      } else {
        newState.searchedCampaigns = [];
        newState.campaignSearchTerm = '';
        newState.isCampaignSearch = false;
      }
      return newState;

    case ANALYTICS_ASSETS_SEARCH.SET:
      if (action.payload?.length > 0) {
        newState.isAssetSearch = true;
        newState.assetSearchTerm = action.payload;
        if (newState.isWorkflow) {
          let srchAssets = state.assets.filter(
            (item: any) =>
              item?.name?.toLowerCase().includes(action.payload?.toLowerCase()) ||
              item?.subject?.toLowerCase().includes(action.payload?.toLowerCase()),
          );
          newState.searchedAssets = [...srchAssets];
        }
      } else {
        newState.searchedAssets = [];
        newState.assetSearchTerm = '';
        newState.isAssetSearch = false;
      }
      return newState;

    case ANALYTICS_ASSETS_SEARCH.RESET:
      newState.searchedAssets = [];
      newState.assetSearchTerm = '';
      newState.isAssetSearch = false;
      return newState;

    case ANALYTICS_ASSETS_SEARCH.SET_FIRST_TIME:
      newState.firstTimeSearch = true;
      return newState;

    case ANALYTICS_WORKFLOWS_SEARCH.SET:
      newState.workflowSearchTerm = action.payload;
      return newState;

    case ANALYTICS_WORKFLOWS_SEARCH.RESET:
      newState.searchedWorkflows = [];
      newState.workflowSearchTerm = '';
      return newState;

    case ANALYTICS_DATA_EXPORT.SET_OPEN:
      newState.showExportPopup = true;
      newState.showExportPopupError = false;
      newState.exportLoading = false;
      if (action.payload) newState.exportEmail = action.payload;
      return newState;
    case ANALYTICS_DATA_EXPORT.SET_ERROR:
      newState.showExportPopupError = true;
      return newState;
    case ANALYTICS_DATA_EXPORT.SET_CLOSE:
      newState.showExportPopupError = false;
      newState.showExportPopup = false;
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_SHARE_PROFILE_FILTER:
      newState.isShareProfile = action.payload;
      if (action.payload === true) {
        newState.changeInAssetIds = true;
      }
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_DAILY_IQ_FILTER:
      newState.isDailyIQ = action.payload;
      if (action.payload === true) {
        newState.changeInAssetIds = true;
      }
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_WEEKLY_ACCOUNTS_INSIGHTS_FILTER:
      newState.isWeeklyAccountInsights = action.payload;
      if (action.payload === true) {
        newState.changeInAssetIds = true;
      }
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.RESET_CONSTANT_FILTERS:
      newState.isShareProfile = false;
      newState.isDailyIQ = false;
      newState.isWeeklyAccountInsights = false;
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_WORKFLOW_FILTER:
      newState.workflowSearchTerm = '';
      newState.isWorkflowFilter = false;
      newState.workflowFilters = { isActive: false, isInactive: false, isAllType: true };
      newState.workflowsLoading = false;
      newState.selectedWorkflowsIds = [];
      newState.isWorkflow = action.payload;
      return newState;

    case GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.FILTER_EMAILS:
      newState.assets = action.payload.assets;
      let campaign_id = action.payload.campaign_id;
      let campaignIds = action.payload.campaignIds;
      let emails_to_show_1: any = [];
      let new_emails_to_show: any = [];
      let new_selected_emails_ids = [...state.selectedAssetsIds];
      action.payload.assets.forEach((item: any) => {
        let id = item.id;
        if (!emails_to_show_1.includes(id)) {
          new_emails_to_show.push(item);
        }
        if (!state.selectedAssetsIds.includes(id)) {
          new_selected_emails_ids.push(id);
        }
      });
      newState.selectedAssetsIds = [...new_selected_emails_ids];
      let updated_emails = [...emails_to_show_1, ...new_emails_to_show];
      newState.selectedCampaignsIds = [...campaignIds];
      newState.selectedAssetsIdsObject[campaign_id] = updated_emails
        .filter((asset: any) => asset.campaignId === campaign_id)
        .map((item: any) => item.id);
      newState.filteredAssets = newState.assets;
      return newState;

    case GET_ANALYTICS_WORKFLOW_FILTERS.SET_FILTERS:
      let filter = Object.keys(action.payload)[0];
      newState.workflowFilters = {
        isActive: false,
        isInactive: false,
        isAllType: false,
        [filter]: true,
      };
      return newState;

    case GET_ANALYTICS_WORKFLOW_LIST.LOAD:
      newState.workflowsLoading = true;
      return newState;

    case GET_ANALYTICS_WORKFLOW_LIST.SUCCESS:
      newState.workflowsLoading = false;
      newState.workflows = action.payload;
      return newState;

    case GET_ANALYTICS_WORKFLOW_LIST.REORDER:
      let beforeWorkflows: any = [];
      let afterWorkflows: any = [];
      state.workflows.forEach((item: ICampaignDropdownItem) => {
        if (state.selectedWorkflowsIds.includes(item.id)) {
          beforeWorkflows.push(item);
        } else {
          afterWorkflows.push(item);
        }
      });
      newState.workflows = [...beforeWorkflows, ...afterWorkflows];
      return newState;

    case GET_ANALYTICS_WORKFLOW_LIST.FAIL:
      newState.workflowsLoading = false;
      return newState;

    case ANALYTICS_DASHBOARD_WORKFLOW.SELECT:
      const selectedWorkflowId = action.payload;
      let newSelectedWorkflowIds: number[] = [];
      if (state.selectedWorkflowsIds.includes(selectedWorkflowId)) {
        // removing from list
        newSelectedWorkflowIds = state.selectedWorkflowsIds.filter((workflowId: number) => workflowId !== selectedWorkflowId);
      } else {
        // adding in the list
        newSelectedWorkflowIds = [selectedWorkflowId];
      }
      newState.selectedCampaignsIds = [];
      newState.selectedWorkflowsIds = [...newSelectedWorkflowIds];
      return newState;

    case ANALYTICS_DASHBOARD_WORKFLOW.FIRST_TIME_SET:
      newState.isWorkflow = action.payload;
      newState.appliedIsWorkflow = action.payload;
      if (action.payload === true) {
        newState.isAssetSearch = false;
      }
      return newState;

    case ANALYTICS_DASHBOARD_WORKFLOW.SET:
      newState.isWorkflow = true;
      newState.appliedIsWorkflow = true;
      newState.selectedCampaignsIds = [];
      newState.appliedCampaignIds = [];
      newState.selectAllDropdownEmails = true;
      newState.unselectAllDropdownEmails = false;
      newState.excludeAssetsIds = [];
      newState.searchedEmailList = [];
      newState.selectedWorkflowsIds = [action.payload];
      newState.appliedWorkflowsIds = [action.payload];
      newState.selectedAssetsIds = [];
      newState.isDefaultDataSet = true;
      return newState;

    case ANALYTICS_DASHBOARD_WORKFLOW.RESET:
      newState.isWorkflow = false;
      // newState.appliedIsWorkflow = false;
      newState.selectedWorkflowsIds = [];
      // newState.appliedWorkflowsIds = [];
      newState.filteredAssets = [];
      newState.isDefaultDataSet = false;
      newState.selectedAssetsIds = [];
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.CAMPAIGN_AND_WORKFLOW_LOAD:
      newState.dropdownCampaignLoading = true;
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.CAMPAIGN_AND_WORKFLOW_SUCCESS:
      newState.dropdownCampaignLoading = false;
      newState.totalDropdownCampaignsCount = action.payload.totalCampaigns;
      newState.campaigns = action.payload.campaigns;
      newState.workflows = action.payload.workflows;
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.CAMPAIGN_AND_WORKFLOW_FAIL:
      newState.dropdownCampaignLoading = false;
      newState.totalDropdownCampaignsCount = 0;
      newState.campaigns = [];
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.RESET_CAMPAIGNS_AND_WORKFLOWS:
      newState.campaigns = [];
      newState.workflows = [];
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_LOAD:
      newState.dropdownEmailLoading = true;
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_SUCCESS:
      newState.dropdownEmailLoading = false;
      if (action.payload.emailSearchTerm) {
        if (action.payload.offset) {
          newState.searchedAssets = [...newState.searchedAssets, ...action.payload.emails];
        } else {
          if (action.payload.searchMarkedCount) {
            newState.totalDropdownEmailMarkedCount =
              newState.totalDropdownEmailMarkedCount - action.payload.searchMarkedCount + action.payload.markedCount;
          }
          newState.searchedAssets = action.payload.emails;
          newState.totalDropdownSearchEmailMarkedCount = action.payload.markedCount;
          newState.totalSearchDropdownEmailsCount = action.payload.total;
        }
      } else {
        if (action.payload.offset) {
          newState.assets = [...newState.assets, ...action.payload.emails.map((email: IEmailDropdownItem) => ({ ...email }))];
          // newState.appliedAssets = [...newState.appliedAssets, ...action.payload.emails.map((email: IEmailDropdownItem) => ({ ...email }))];
        } else {
          newState.assets = action.payload.emails.map((email: IEmailDropdownItem) => ({ ...email }));
          // newState.appliedAssets = action.payload.emails.map((email: IEmailDropdownItem) => ({ ...email }));
          newState.totalDropdownEmailMarkedCount = action.payload.markedCount;
          // newState.appliedEmailMarkedCount = action.payload.markedCount;
          if (action.payload.isWorkflow) {
            newState.selectedAssetsIds = action.payload.emails.map((asset: IAssetDropdownItem) => asset.id);
            newState.unselectAllDropdownEmails = true;
            newState.selectAllDropdownEmails = false;
          }
        }
        newState.totalDropdownEmailsCount = action.payload.total;
        if (newState.totalDropdownEmailsCount === 0) newState.prevTotalDropdownEmailsCount = action.payload.total;
      }
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_FAIL:
      newState.dropdownEmailLoading = false;
      newState.assets = [];
      newState.totalDropdownEmailsCount = 0;
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_RESET:
      newState.assets = [];
      // newState.totalDropdownEmailsCount = 0;
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.SEARCH_EMAIL_RESET:
      newState.searchedAssets = [];
      newState.totalSearchDropdownEmailsCount = 0;
      return newState;

    case GET_ANALYTICS_FILTERS_DROPDOWN_DATA.SET_EMAIL_MARKED_COUNT:
      newState.totalDropdownEmailMarkedCount = action.payload;
      return newState;

    default:
      return newState;
  }
};

const checkAssetFilters = (asset: IAssetDropdownItem, filters: { isCustom: boolean; isHybrid: boolean }) => {
  const { isCustom, isHybrid } = filters;
  if (isCustom && isHybrid) {
    return asset.isCustom === true || asset.isHybrid === true;
  } else if (isCustom) {
    return asset.isCustom === true && asset.isHybrid === false;
  } else if (isHybrid) {
    return asset.isCustom === false && asset.isHybrid === true;
  } else {
    return true;
  }
};

const checkSelectedOrSearchCampaigns = (asset: IAssetDropdownItem, searchTerm: string, selectedCampaignsIds: number[]) => {
  if (searchTerm) {
    return asset.name.toLowerCase().includes(searchTerm.toLowerCase());
  } else {
    return selectedCampaignsIds.includes(asset.campaignId);
  }
};

const checkExcludeAssetExist = (assetId: number, excludeAssetsIds: number[]) => {
  // if user want to include an asset
  // just checking that if it exists in excludeAssetsIds then remove it from it.
  let updatedExcludeAssetsIds = [...excludeAssetsIds];
  if (excludeAssetsIds.includes(assetId)) {
    const index = updatedExcludeAssetsIds.indexOf(assetId);
    if (index > -1) {
      // only splice array when item is found
      updatedExcludeAssetsIds.splice(index, 1); // 2nd parameter means remove one item only
    }
  }
  return updatedExcludeAssetsIds;
};

const getFilteredList = (
  obj: {
    isCustom: boolean;
    isHybrid: boolean;
    isAllType: boolean;
    isAIEmail: boolean;
  },
  isAssetSearch: boolean,
  assetSearchTerm: string,
  filteredAssets: IAssetDropdownItem[],
  selectedCampaignsIds: number[],
  isTestEmail: boolean,
  date: { label: string; value: string },
) => {
  let isHybrid = obj.isHybrid;
  let isCustom = obj.isCustom;
  let isAllType = obj.isAllType;
  let isAIEmail = obj.isAIEmail;
  let startDate: string, endDate: string;
  if (date.value === 'custom') {
    startDate = date.label.split(' to ')[0];
    endDate = date.label.split(' to ')[1];
  } else {
    const dateObj: any = getDateObject(date.value);
    startDate = dateObj.start_date;
    endDate = dateObj.end_date;
  }
  filteredAssets = filteredAssets.filter((item: any) => {
    const itemDateTime = new Date(item.dateTime);
    const start = new Date(startDate);
    const end = new Date(endDate);
    return itemDateTime >= start && itemDateTime <= new Date(end.setDate(end.getDate() + 1));
  });
  if (isAssetSearch) {
    filteredAssets = filteredAssets.filter((item: any) => item?.name?.toLowerCase().includes(assetSearchTerm.toLowerCase()));
  } else {
    filteredAssets = filteredAssets.filter((item: any) => selectedCampaignsIds.includes(item.campaignId));
  }

  if (!isTestEmail) {
    filteredAssets = filteredAssets.filter((item: any) => item?.isTestEmail === false);
  }

  if (isAllType) {
    return filteredAssets;
  } else if (isHybrid) {
    return filteredAssets.filter((item: any) => item.isHybrid === isHybrid);
  } else if (isCustom) {
    return filteredAssets.filter((item: any) => item.isCustom === isCustom);
  } else if (isAIEmail) {
    return filteredAssets.filter((item: any) => item.isAIEmail === isAIEmail);
  } else {
    return [];
  }
};

const applyFiltersOnFilteredList = (obj: { isCustom: boolean; isHybrid: boolean; isAllType: boolean }, filteredAssets: IAssetDropdownItem[]) => {
  let isHybrid = obj.isHybrid;
  let isCustom = obj.isCustom;
  let isAllType = obj.isAllType;
  if (isAllType) {
    return filteredAssets;
  } else if (isHybrid) {
    return filteredAssets.filter((item: any) => item.isHybrid === isHybrid);
  } else if (isCustom) {
    return filteredAssets.filter((item: any) => item.isCustom === isCustom);
  } else {
    return [];
  }
};

const initialGraphDataState: ILoadingOptionsWithData = {
  loading: false,
  data: {},
  deliveredEmailsSorted: {},
  startDate: '',
  endDate: '',
  appliedStartDate: '',
  appliedEndDate: '',
  userId: 'default',
  isEmpty: false,
  dates: [
    { label: 'All time', value: 'all' },
    { label: '1 QTR', value: 'qtr' },
    { label: 'Month', value: 'month' },
    { label: 'Week', value: 'week' },
    { label: 'Day', value: 'day' },
    { label: 'Custom', value: 'custom' },
  ],
  selectedDates: 'qtr',
  selectedDatesObject: { label: '1 QTR', value: 'qtr' },
  appliedDates: 'qtr',
  appliedDatesObject: { label: '1 QTR', value: 'qtr' },
  restrictEmailDropdownAPICall: false,
};

export const analyticsGraphReducer = (state: ILoadingOptionsWithData = initialGraphDataState, action: IGraphDataAction) => {
  const newState: ILoadingOptionsWithData = { ...state };
  switch (action.type) {
    case ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_SUCCESS:
      newState.loading = false;
      newState.data = { ...state.data, ...action.payload };
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD:
      newState.loading = true;
      newState.data = {};
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_FAIL:
      newState.loading = false;
      newState.data = {};
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.CLEAR:
      newState.loading = false;
      newState.data = {};
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT:
      newState.selectedDates = action.payload.value;
      newState.selectedDatesObject = action.payload;
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES:
      if (action.start_date && action.end_date) {
        newState.startDate = action.start_date;
        newState.endDate = action.end_date;
      }
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES_OBJECT:
      newState.appliedDates = action.payload.value;
      newState.appliedDatesObject = action.payload;
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES:
      if (action.start_date && action.end_date) {
        newState.appliedStartDate = action.start_date;
        newState.appliedEndDate = action.end_date;
      }
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.RESET_DATES:
      newState.startDate = '';
      newState.endDate = '';
      newState.appliedStartDate = '';
      newState.appliedEndDate = '';
      newState.selectedDates = 'qtr';
      newState.selectedDatesObject = { label: '1 QTR', value: 'qtr' };
      newState.appliedDates = 'qtr';
      newState.appliedDatesObject = { label: '1 QTR', value: 'qtr' };
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.SET_USER:
      if (action.user_id) newState.userId = action.user_id;
      return newState;

    case ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DELIVERED_EMAIL:
      newState.deliveredEmailsSorted = action.payload.delivered_emails;
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET:
      newState.appliedDates = newState.selectedDates;
      newState.appliedDatesObject = newState.selectedDatesObject;
      newState.appliedStartDate = newState.startDate;
      newState.appliedEndDate = newState.endDate;
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET:
      if (newState.startDate !== newState.appliedStartDate || newState.endDate !== newState.appliedEndDate) {
        newState.restrictEmailDropdownAPICall = true;
      }
      newState.selectedDates = newState.appliedDates;
      newState.selectedDatesObject = newState.appliedDatesObject;
      newState.startDate = newState.appliedStartDate;
      newState.endDate = newState.appliedEndDate;
      return newState;

    case ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET_RESTRICT_EMAIL_DROPDOWN_PARAM:
      newState.restrictEmailDropdownAPICall = false;
      return newState;

    default:
      return state;
  }
};
